<template>
    <el-dialog ref="changeWorkOrderDialog" :before-close="handleDialogClose" :modal-append-to-body="false" :close-on-click-modal="false" title="选择工单" :visible.sync="changeWorkOrderDialog" class="custom-form-dialog custom_dialog" width="860px">
        <div class="detail">
            <div class="relate_approval_wrap">
                <div class="relate_approval_search">
                    <el-input size="small" v-model="searchForm.keyword" placeholder="请输入搜索内容"  clearable  @clear="handleClickSearch"  @keyup.enter.native="handleClickSearch">
                        <i slot="suffix" class="el-icon-search" @click="handleClickSearch"></i>
                    </el-input>
                    <el-date-picker  v-model="searchForm.created_at" size="small"  format="yyyy-MM-dd" value-format="yyyy-MM-dd"  type="daterange" @change="handleClickSearch" start-placeholder="创建开始日期"
                                     end-placeholder="创建结束日期"> </el-date-picker>
                </div>
                <div class="relate_approval_list">
                    <el-table class="custom_table" :data="tableData" border height="480px" ref="multipleTable" row-key="workorder_id"  @selection-change="handleSelectionChange">
                        <el-table-column :resizable="false" type="selection"   align="center"  width="45" :reserve-selection="true" :selectable="isSelectable"></el-table-column>
                        <el-table-column label="工单编号" prop="workorder_num" show-overflow-tooltip width="140px">
                            <template slot-scope="{row}">
                                <span class="link-label" v-text="row.workorder_num"></span>
                            </template>
                        </el-table-column>

                        <el-table-column label="关联商机" prop="project" show-overflow-tooltip min-width="140px">
                            <template slot-scope="{row}">
                                <span @click="handleClickBusinessDetail({project_id:row.project.id, name:row.project.name})" class="link-label" v-text="row.project.name"></span>
                            </template>
                        </el-table-column>

                        <el-table-column label="发起人" prop="user" show-overflow-tooltip min-width="120px">
                            <template slot-scope="{row}">
                                <userDetailPopover v-if="row.user" :uid="row.user.id">
                                    <div slot="container">
                                        <div class="user_head">
                                            <img :src=" row.user.avatar ? row.user.avatar : defaultImg" alt="" />
                                            <span v-text="row.user.name"></span>
                                        </div>
                                    </div>
                                </userDetailPopover>
                            </template>
                        </el-table-column>

                        <el-table-column label="工单类型" prop="workorder_type_id" show-overflow-tooltip width="100px">
                            <template slot-scope="{row}">
                                    <span v-text="row.workorder_type_id.name"></span>
                            </template>
                        </el-table-column>

                        <el-table-column label="计划时间" prop="plan_start_date" show-overflow-tooltip width="240px">
                            <template slot-scope="{row}">
                                <span v-text="row.plan_start_date"></span>
                                <span v-text="row.plan_start_time == 1 ? '上午': '下午'"></span> -
                                <span v-text="row.plan_end_date"></span>
                                <span v-text="row.plan_end_time == 1 ? '上午': '下午'"></span>
                            </template>
                        </el-table-column>
                        <el-table-column label="实施人" prop="processing_users" show-overflow-tooltip width="110px">
                            <template slot-scope="{row}">
                                <span v-if="row.processing_users" v-text="row.processing_users.map(map => map.processing_user.name).join(',')"></span>
                            </template>
                        </el-table-column>

                    </el-table>
                </div>
                <div class="relate_approval_page">
                    <el-pagination background
                                   size="mini"
                                   @size-change="handleSizeChange"
                                   @current-change="handleCurrentChange"
                                   :current-page="pagination.pageNum"
                                   :page-sizes="pagination.pageSizes"
                                   :page-size="pagination.pageSize"
                                   :layout="pagination.layout"
                                   :pager-count="5"
                                   :total="pagination.total">
                    </el-pagination>
                </div>
            </div>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click.stop="handleDialogClose">取消</el-button>
            <el-button :disabled="BtnDisabled" type="primary" @click.stop="handleDialogConfirm" >确定</el-button>
        </span>
    </el-dialog>
</template>
<script>
import {getWorkOrderList } from "@/api/index.js"
import {pagination} from '@/mixins'
import userDetailPopover from "@/components/pComponents/userDetailPopover";
export default {
    name: "change_work_order",
    components: {
        userDetailPopover
    },
    props: {
        changeWorkOrderDialog: {
            type: Boolean,
            default: false
        },
        work_order_pk_sort: {
            type: Object,
            default: ()=>{}
        },
        selectWorkOrderData: {
            type: Array,
            default: ()=>[]
        },
        disabledData: {
            type: Array,
            default: ()=>[]
        }, //不可选择的工单
    },
    mixins: [pagination],
    data() {
        return {
            defaultImg: require("@/assets/images/default.jpg"),
            BtnDisabled:false,
            searchForm:{
                keyword:'',
                created_at:[]
            },
            tableData:[],
            select_order_ids:[],
            multipleSelection:[]
        }
    },
    created() {
        this.$nextTick(()=>{
            this.multipleSelection = JSON.parse(JSON.stringify(this.selectWorkOrderData))
            this.multipleSelection.forEach(row => {
                this.$refs.multipleTable.toggleRowSelection(row);
            });
        })

        this.getWorkOrderListData()
        console.log(this.disabledData)
    },
    methods: {
        isSelectable(row, index) {
            return this.disabledData.find(find => find.workorder_id == row.workorder_id) ?  false  : true
        },
        handleSelectionChange(selection){
            this.multipleSelection = selection;
        },
        handleClickSearch(){
            this.getWorkOrderListData()
        },
        // 页码改变
        handleCurrentChange(val) {
            this.pagination.pageNum = val;
            this.handleClickSearch();
        },
        // 页数改变
        handleSizeChange(page) {
            this.pagination.pageNum = 1;
            this.pagination.pageSize = page.pageSize
            this.handleClickSearch();
        },
        getWorkOrderListData() {
            getWorkOrderList({
                form_base:true,
                page: this.pagination.pageNum,
                pageSize: this.pagination.pageSize,
                keyword:this.searchForm.keyword,
                created_at:this.searchForm.created_at,
                pk_sort:this.work_order_pk_sort
            }).then(res => {
                if (res.code === 200) {
                    const {data, total} = res.data
                    data.forEach(item=>{
                        this.$set(item,'workorder_id',item.id)
                    })
                    this.tableData = data
                    this.pagination.total = total

                } else {
                    this.$message.error(res.message)
                }
            })
        },
        handleDialogClose() {
            this.$emit("update:changeWorkOrderDialog", false)
        },
        handleDialogConfirm() {
            this.$emit("update:changeWorkOrderDialog", false)
            this.$emit('success', this.multipleSelection)
        },

        //点击查看商机详情
        handleClickBusinessDetail({project_id, name}) {
            this.$router.push({
                name: "BusinessDetail",
                params: {
                    isPush: true,
                },
                query: {
                    project_id: project_id,
                    name: name,
                },
            });
        },


    }
}
</script>
<style lang="scss" scoped>
.relate_approval_wrap{
    width: 100%;
    .relate_approval_search{
        display: flex;
        margin-bottom: 16px;
        .el-select{
            width: 272px;

        }
        .el-input{
            width: 272px;
            margin-right: 16px;
        }
        ::v-deep .el-input__suffix {
            line-height: 32px;
        }
    }
    .relate_approval_list{

    }
    .relate_approval_page{
        padding: 16px 0 0;
        box-sizing: border-box;
    }
}
.user_head{
    width: 100%;
    line-height: 24px;
    display: flex;
    align-items: center;
    cursor: pointer;
    img{
        width: 24px;
        height: 24px;
        border-radius: 50%;
        display: inline-block;
        margin-right: 8px;
    }
    span{
        font-size: 14px;
        color: rgb(102, 102, 102);
    }
}
</style>
